import '../scss/main.scss';
import './polyfills.ts';

import { StyleService } from './services/style-service';
import { UtilityService } from './services/utility.service';
import { MainViewController } from './ui-components/usercentrics-button/main-view-controller';
import { SettingsService } from './services/settings-service';
import { WindowUsercentricsService } from './services/utilities/window-usercentrics.service';

declare global {
    interface Window {
        usercentrics: any;
        toUsercentrics: any;
        globalConsentCookie: any;
        tousercentrics: any;
        _: any;
        localhost: boolean;
        lodash: any;
        getVendorList: any;
        getPurposes: any;
        createCookieWithoutDomain: any;
        createCookieWithDomain: any;
        createCookie: any;
        readCookie: any;
        uc?: any;
    }
}
const utilityService: UtilityService = new UtilityService();

window.usercentrics = window.usercentrics || {};
window.tousercentrics = window.tousercentrics || {};
window.usercentrics.consents = window.usercentrics.consents || [];

// This attaches all window functions to the global object
new WindowUsercentricsService(utilityService);

// detaching lodash from window._
window.lodash = window._.noConflict();

/**
 * App backend initialization.
 * TASKS:
 * - All tasks are to be performed in this function only.
 * - Try to get settings and consent templates from the local storage.
 * - If they are empty then send empty consents_initialized event into the data exchange.
 *   (Will happen on the first time ) then go to step X.
 * - If they are not empty then trigger initializeConsentsAndCategories function.
 * - Get the consents only those that need to be pushed into the data layer.
 * - Push 'consent_initialized from the local storage event' into the Data Exchange.
 * - Trigger function for enabling or disabling scripts on the page based on the consents.
 * - X) Get settings from the server.
 * - deactivated consent templates need to be spliced.
 * - Get the consents ( only those that need to be pushed into the data layer. Please
 *   take care not to get deactivated or other disabled consents. (Confirm this))
 * - Push consent initialized from the server event into the data exchange.
 * - Trigger function for enabling or disabling scripts on the page based on the consents.
 * - get first time interaction variable from local storage.
 * - If no first time interaction variable create first time interaction variable.
 * - If it is first time interaction set showbanner variable to true
 * - Create the mainviewcontroller.
 */

async function executeApp() {
    const styleService: any = new StyleService();
    const settingsService: SettingsService = utilityService.settingsService;

    utilityService.developmentLog('calling initSettings from app.ts');
    utilityService.developmentLog('isBotDetected: ', utilityService.userAgentService.detectBot());
    try {
        await settingsService.initSettings();
    } catch (e) {
        console.error('Unable to initialize settings', e);
        throw e;
    }
    utilityService.developmentLog('got data from initSettings in app.ts');
    if (!settingsService.settings.disableScriptIfBot || !utilityService.userAgentService.detectBot()) {
        utilityService.initOnGetSetting();
        setTimeout(() => {
            utilityService.developmentLog('initializing main view controller from app.ts');
            const mainView = new MainViewController(styleService, utilityService);
            settingsService.mainViewController = mainView;
            mainView.initView();
        });
    }

    if (!window.usercentrics) {
        window.usercentrics = {};
    }
}

executeApp();

